<template>
    <div class="form-group">
        <label for="select-status">{{ categoryName }}</label>
        <loader :show="isLoading" :width="40" :height="40"></loader>

        <select
                v-if="!isLoading"
                v-model="selected"
                @change="notifySuperComponent()"
                name="Category"
                class="custom-select"
        >
            <slot name="options">
                  <option :value="-1" disabled>Tutte</option>
            </slot>
            <option
                    v-for="(item, i) in options_data"
                    :value="i"
                    :key="item.id"
            >{{item.name}}
            </option>
        </select>
    </div>
</template>

<script>
    import axios from "axios";
    import {isNumber} from 'util';

    export default {
        name: "CategoryBox",

        data() {
            return {
                options_data: [],
                selected: null,
                isLoading: true
            };
        },
        props: {
            mainCategory: {
                type: Number,
                default: 1
            },
            categoryName: {
                type: String,
                default: ''
            },
            value: {
                type: Object,
                default: () => ({'id': -1})
            }
        },

        watch: {
            value: function () {
                let findingValue = this.value ? (isNumber(this.value) ? {id: this.value} : this.value) : {id: -1};
                this.selected = this.options_data.findIndex((o) => o.id == findingValue.id);
            }
        },

        methods: {
            notifySuperComponent: function () {
                this.$emit("input", this.options_data[this.selected]);
                this.$emit("change", this.selected)
            },

            async asyncRelatedStatuses() {
                let self = this;
                self.isLoading = true;

                return await axios({
                    method: "GET",
                    url: self.$url + "operations/categories",
                    params: {
                        main: this.mainCategory,
                        lang: self.$config.getLanguage(),
                    },
                    headers: this.$config.axiosHeaders()
                })
                    .then(function (response) {
                        self.options_data = [...response.data.data]
                        let findingValue = self.value ? (isNumber(self.value) ? {id: self.value} : self.value) : {id: -1};
                        self.selected = self.options_data.findIndex((o) => o.id == findingValue.id);
                    })
                    .catch(function (error) {
                        self.$processError(error);
                        
                    })
                    .finally(
                        () => self.isLoading = false
                    );
            },
        },
        created() {
            this.asyncRelatedStatuses();
        }
    }; // export
</script>
